exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loading-bar{text-align:left;margin:20px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/Modules/LoadingBar/LoadingBar.less
// module id = 1601
// module chunks = 0